import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = ({isDarkMode}) => {
    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4" style={{ color: isDarkMode ? '#f8f9fa' : '#333' }}>Our Privacy Policy</h1>
            <p style={{ color: isDarkMode ? '#f8f9fa' : '#333' }}>
                User Privacy Description:

                "At our Scholarship Platform, we are committed to protecting your privacy and ensuring the security of your personal information. We understand the importance of maintaining the confidentiality of your data, and we adhere to strict privacy practices to safeguard your information.

                When you use our platform to save your favorite scholarships, we only collect your email address for the sole purpose of providing you with personalized updates and notifications related to your saved scholarships. Your email address will not be used for any other purposes, and we will not share it with any third parties without your explicit consent.

            </p>
            <p style={{ color: isDarkMode ? '#f8f9fa' : '#333' }}>
                We utilize industry-standard security measures to prevent unauthorized access, disclosure, or alteration of your email address. Our platform employs encryption protocols and secure storage systems to protect your information from cyber threats and unauthorized access.

                Furthermore, we are committed to transparency and accountability regarding our data handling practices. Our Privacy Policy outlines our procedures for data collection, usage, and disclosure, ensuring that you have full visibility into how your information is being managed.

                Your trust is paramount to us, and we take your privacy seriously. If you have any questions or concerns about our privacy practices or how your information is being handled, please don't hesitate to contact us. Thank you for entrusting us with your privacy as you explore and save scholarships on our platform."
            </p>
            <p>
                <Link to="/" className="btn btn" style={{ backgroundColor: isDarkMode ? '#f8f9fa' : '#333',color: isDarkMode ? '#333' : '#f8f9fa' }}>Back to Home</Link>
            </p>
        </div>
    );
};

export default PrivacyPage;
